import $ from 'jquery'
import complaints from "./complaints";
import customSelect from './custom-select';
import contactForm from "./contact-form";

const dynamicContent = {
    settings : {
        action : `${compensa_general.link}/wp/wp-admin/admin-ajax.php`
    },
    renderModalOnClick() {
        const main = document.querySelector('.main');
        const complaintsModalTrigger = document.querySelector('.js-open-complaints-modal');

        $(complaintsModalTrigger).on('click', function () {
            const complaintsModal = document.querySelector('.js-complaints-modal');
            if (complaintsModal) {
                return
            } else {
                $(complaintsModalTrigger).css('pointer-events', 'none')
                $.ajax({
                    method : 'POST',
                    url : `${compensa_general.link}/wp/wp-admin/admin-ajax.php`,
                    data : {
                        'action' : 'dynamic_content',
                    },
                    success:function ( data ) {
                        $(main).prepend(data)
                        complaints.init();
                        customSelect.customSelect('.js-complaints-modal .custom-select');
                        $('.js-complaints-modal').fadeIn()
                        contactForm.init();
                        $(complaintsModalTrigger).css('pointer-events', 'auto')
                    },
                })
            }
        })

    }
}
export default dynamicContent;